import {
  CountryCodeSelect,
  HelperText,
  PhoneNumberInput,
  PhoneNumberLayout,
} from "../AddPatientGroup.style";
import { CountryCode } from "@home-health-notify/domain";
import { formatPhoneNumberInput, useTranslation } from "hhn-commons";
import * as React from "react";
import { useEffect, useState } from "react";
import { errorsType } from "../PatientGroupUtils";

type InputPhoneNumberProps = {
  patientInfoData: any;
  onFormDataChange: (key: string, value: string) => void;
  onSetErrors: (key: string, value: boolean) => void;
  errors: errorsType;
};
export const InputPhoneNumber = ({
  patientInfoData,
  onFormDataChange,
  onSetErrors,
  errors,
}: InputPhoneNumberProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "patientGroup" });

  const [errorMessage, setErrorMessage] = useState<string>("");

  const handlePhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    checkPhoneNumberLength(input);
    let newStr = input && input.replace(/-|\(|\)| /g, "");
    onFormDataChange("phoneNo", newStr);
  };

  function checkPhoneNumberLength(number: string) {
    if (number.length <= 0) {
      setErrorMessage(tNs("emptyPhoneNumber"));
      onSetErrors("phoneNumber", true);
    }

    if (number.length > 0) {
      number = number.replace(/-|\(|\)| /g, "");
      setErrorMessage(
        number.length > 10 || number.length < 10
          ? tNs("invalidPhoneNumber")
          : "",
      );
      onSetErrors("phoneNumber", number.length > 10 || number.length < 10);
    }
  }

  // patientInfoData.phoneNo can arrive pre-populated (EMR sync, paste parser,
  // opening an existing group for edit) without ever going through
  // handlePhoneChange/onBlur above, which would otherwise leave an invalid
  // value silently blocking submission with no visible error (WEB-APP-WS).
  useEffect(() => {
    if (patientInfoData.phoneNo) {
      checkPhoneNumberLength(patientInfoData.phoneNo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientInfoData.phoneNo]);

  return (
    <>
      <PhoneNumberLayout>
        <CountryCodeSelect
          value={patientInfoData.countryCode}
          data-testid="patient-country-code"
          onChange={event =>
            onFormDataChange("countryCode", event.target.value as CountryCode)
          }
          id="selectCountryCode"
        >
          <option value={CountryCode.US}>
            ({CountryCode.US}) United States
          </option>
          <option value={CountryCode.INDIA}>({CountryCode.INDIA}) India</option>
          <option value={CountryCode.PHILIPPINES}>
            ({CountryCode.PHILIPPINES}) Philippines
          </option>
        </CountryCodeSelect>
        <PhoneNumberInput
          variant="standard"
          required
          id="phone-number"
          label={tNs("phoneNumberLabel")}
          value={formatPhoneNumberInput(
            patientInfoData.phoneNo,
            patientInfoData.countryCode,
          )}
          onBlur={e => checkPhoneNumberLength(e.target.value)}
          onChange={handlePhoneChange}
          error={errors.phoneNumber}
          slotProps={{
            inputLabel: { shrink: !!patientInfoData.phoneNo },
            htmlInput: {
              "data-testid": "patient-phone-number",
              maxLength: patientInfoData.countryCode === "+1" ? 14 : 10,
            },
          }}
        />
      </PhoneNumberLayout>
      <HelperText>{errorMessage}</HelperText>
    </>
  );
};
